//editMode
export const EDIT_MODE_ON = "EDIT_MODE_ON";
export const EDIT_MODE_OFF = "EDIT_MODE_OFF";
export const SET_EDIT_MODE = "SET_EDIT_MODE";
export const CLEAR_EDIT_MODE = "CLEAR_EDIT_MODE";
export const SET_LEVEL = "SET_LEVEL";
